import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "hello" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" For a guide and recipes on how to configure / customize this project,"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" check out the "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://cli.vuejs.org",
        target: "_blank",
        rel: "noopener"
    }, "vue-cli documentation"),
    /*#__PURE__*/ _createTextVNode(". ")
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", null, "Installed CLI Plugins", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("ul", null, [
            _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.changeUrl('here')))
            }, "typescript")
        ])
    ]));
}
